import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import CustomProductCard from 'utils/custom-product-card';
import { Navigation, Scrollbar, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowIcon from 'utils/icon/arrow.svg';

const ProductCarousel = ({
  products,
  layout,
  useExtendedFunctionality,
  hasSectionContent,
  sectionName,
  sectionId,
}) => {
  const [isDesktop, setIsDesktop] = useState(layout.bps.above.lg.matches);
  const carouselRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(layout.bps.above.lg.matches);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [layout.bps.above.lg]);

  if (!products.length) return false;

  const mainContent = document.querySelector('#MainContent');
  const sections = mainContent.querySelectorAll('.shopify-section');
  const sectionIndex = [...sections].findIndex((el) => el.id === `shopify-section-${sectionId}`);

  const trackingData = {
    contentName: `${sectionName} view`,
    contentPage: `${window.location.href}`,
    contentPosition: sectionIndex + 1,
  };

  const slideWidthClass = 'w-[212px] lg:w-[278px] h-auto';

  const isProductAvailable = (product) => {
    const { bundle, variants } = product;
    return bundle
      ? bundle.available
      : variants && variants.length > 0
      ? variants[0].availableForSale || variants[0].available
      : false;
  };

  return (
    <div ref={carouselRef}>
      <Swiper
        slidesPerView={'auto'}
        spaceBetween={isDesktop ? 24 : 20}
        modules={[Navigation, Scrollbar, Mousewheel]}
        mousewheel={{ forceToAxis: true }}
        navigation={{
          nextEl: '.products-carousel-button-next',
          prevEl: '.products-carousel-button-prev',
        }}
        scrollbar={{ draggable: true }}
      >
        <div className="products-carousel-buttons-wrapper">
          <button
            className={`swiper-button swiper-button-prev 
                      products-carousel-button-prev 
                     !w-[40px] !h-[40px] bg-black rotate-180 text-white rounded-full ${
                       hasSectionContent ? 'left-0' : 'products-carousel-button-prev--left'
                     }`}
          >
            <ArrowIcon />
          </button>
          <button className="swiper-button swiper-button-next products-carousel-button-next !w-[40px] !h-[40px] bg-black right-0 text-white rounded-full">
            <ArrowIcon />
          </button>
        </div>
        {products.map((product, index) => {
          if (!isProductAvailable(product)) return null;
          return (
            <SwiperSlide
              key={product.id}
              className={`${slideWidthClass} ${index === products.length - 1 ? 'lg:mr-[50px]' : ''}`}
            >
              <CustomProductCard
                product={product}
                useExtendedFunctionality={useExtendedFunctionality}
                layout={layout}
                trackingData={trackingData}
                isDesktop={isDesktop}
                carouselRef={carouselRef}
                carouselId={`carousel-${sectionId}`}
                index={index}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ProductCarousel;
